import React from "react";
import "./App.css";
import MyEditor from "./MyEditor/MyEditor";

function App() {
  return (
    <MyEditor/>
  );
}

export default App;
